import React from "react";
import contextProvider from "app/contextProvider";
import { Link } from "react-router-dom";
import _ReactOBaseComponent from "app/_L0_components/_ReactOBaseComponent";
import Section from "app/_L1_components/Layout/Section";
import ReactOTable from "app/_L1_components/Elements/ReactOTable";
import ReactOButton from "app/_L1_components/Elements/ReactOButton";

class Dev extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {};
    super(props, initState);
  }

  onRender() {
    return (
      <Section
        designType="narrow"
        className={this.getAppContext().media.isMobile ? "mt-1" : "mt-3"}
      >
        <ReactOTable
          thClassName="px-3 py-1"
          tdClassName="align-middle px-3 py-2"
          thDividers
          cols={[
            {
              title: "Element",
              data_key: "elem",
              align: "left",
              width: "25",
              sortable: true,
            },
            {
              title: "Font size",
              data_key: "size",
              align: "left",
              width: "25",
              sortable: true,
            },
            {
              title: "Color",
              data_key: "color",
              align: "left",
              width: "25",
              sortable: true,
            },
            {
              title: "Pages",
              data_key: "pages",
              align: "left",
              width: "25",
              sortable: true,
            },
          ]}
          defaultSort={[
            {
              data_key: "elem",
              order: "asc",
            },
          ]}
          rows={[
            {
              elem: {
                value: "Dato singolo",
                render: (
                  <Link
                    to={{
                      pathname: "/a00/fontdemo",
                      // params: {
                      //   tag: "h4",
                      //   title: "Dato singolo - h4, font-size:24px, color: #212529",
                      // },
                    }}
                    target="_blank"
                  >
                    <div>
                      <div>
                        {" "}
                        <h4>Dato singolo</h4>{" "}
                      </div>
                      <div>
                        {" "}
                        <h4>Titolo pagina</h4>{" "}
                      </div>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "h4, font-size:24px",
                render: "h4, font-size:24px",
              },
              color: {
                value: "#212529",
                render: "#212529",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a
                      title="Dato singolo"
                      href="/de446db4cce3/active/FCAMobile-k31ZL/ccd539bb7fc5"
                      target="_blank"
                    >
                      Active
                    </a>
                    <a
                      title="Dato singolo"
                      href="/de446de09228/active/FCAMobile-S1mda/overal"
                      target="_blank"
                    >
                      Overall
                    </a>
                    <a
                      title="Dato singolo"
                      href="/de446de09228/active/FCAMobile-S1mda/overal/results/1592280960/i"
                      target="_blank"
                    >
                      Results
                    </a>
                    <a title="Tiolo pagina" href="/sdconf" target="_blank">
                      SD Conf
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Dato singolo",
                render: (
                  <Link
                    to={{
                      pathname: "/a01/fontdemo",
                    }}
                    target="_blank"
                  >
                    {" "}
                    <h4 className="text-success">Dato singolo</h4>{" "}
                  </Link>
                ),
              },
              size: {
                value: "h4, font-size:24px",
                render: "h4, font-size:24px",
              },
              color: {
                value: "#28a745",
                render: "#28a745",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a
                      href="/de446de09228/active/FCAMobile-S1mda/overal/results/1592280960/i"
                      target="_blank"
                    >
                      Results
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Dato singolo",
                render: (
                  <Link
                    to={{
                      pathname: "/a02/fontdemo",
                    }}
                    target="_blank"
                  >
                    <h4 style={{ color: "#0774f2" }}>Dato singolo</h4>
                  </Link>
                ),
              },
              size: {
                value: "h4, font-size:24px",
                render: "h4, font-size:24px",
              },
              color: {
                value: "#0774f2",
                render: "#0774f2",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a
                      href="/de446db4cce3/active/FCAMobile-k31ZL/ccd539bb7fc5"
                      target="_blank"
                    >
                      Active
                    </a>
                    <a href="/de446de09228/active/FCAMobile-S1mda/overal" target="_blank">
                      Overall
                    </a>
                    <a
                      href="/de446de09228/active/FCAMobile-S1mda/overal/results/1592280960/i"
                      target="_blank"
                    >
                      Results
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Dato singolo",
                render: (
                  <Link
                    to={{
                      pathname: "/a03/fontdemo",
                    }}
                    target="_blank"
                  >
                    {" "}
                    <h4 style={{ color: "#3489f4" }}>Dato singolo</h4>
                  </Link>
                ),
              },
              size: {
                value: "h4, font-size:24px",
                render: "h4, font-size:24px",
              },
              color: {
                value: "#3489f4",
                render: "#3489f4",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a
                      href="/de446db4cce3/active/FCAMobile-k31ZL/ccd539bb7fc5"
                      target="_blank"
                    >
                      Active
                    </a>
                    <a href="/de446de09228/active/FCAMobile-S1mda/overal" target="_blank">
                      Overall
                    </a>
                    <a
                      href="/de446de09228/active/FCAMobile-S1mda/overal/results/1592280960/i"
                      target="_blank"
                    >
                      Results
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Dato singolo",
                render: (
                  <Link
                    to={{
                      pathname: "/a04/fontdemo",
                    }}
                    target="_blank"
                  >
                    {" "}
                    <h4 style={{ color: "#62BFF9" }}>Dato singolo</h4>{" "}
                  </Link>
                ),
              },
              size: {
                value: "h4, font-size:24px",
                render: "h4, font-size:24px",
              },
              color: {
                value: "#62BFF9",
                render: "#62BFF9",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a
                      href="/de446db4cce3/active/FCAMobile-k31ZL/ccd539bb7fc5"
                      target="_blank"
                    >
                      Active
                    </a>
                    <a href="/de446de09228/active/FCAMobile-S1mda/overal" target="_blank">
                      Overall
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Dato singolo",
                render: (
                  <Link
                    to={{
                      pathname: "/a05/fontdemo",
                    }}
                    target="_blank"
                  >
                    <h4 className="text-danger">Dato singolo</h4>
                  </Link>
                ),
              },
              size: {
                value: "h4, font-size:24px",
                render: "h4, font-size:24px",
              },
              color: {
                value: "#dc3545",
                render: "#dc3545",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a
                      href="/de446db4cce3/active/FCAMobile-k31ZL/ccd539bb7fc5"
                      target="_blank"
                    >
                      Active
                    </a>
                    <a href="/de446de09228/active/FCAMobile-S1mda/overal" target="_blank">
                      Overall
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value:
                  "Menu link, legenda, descrizione, Testo cella <td> singolo, testo singolo form",
                render: (
                  <Link
                    to={{
                      pathname: "/a11/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div>
                      <div>Menu link</div>
                      <div>Legenda</div>
                      <div>Descrizione</div>
                      <div>Testo singolo form</div>
                      <div>Titolo sezione modale</div>
                      <div>Titolo sezione modale</div>
                      <div>Testo cella &lt;td&gt; singolo</div>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "font-size:16px",
                render: "font-size:16px",
              },
              color: {
                value: "#212529",
                render: "#212529",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <div title="Menu link">Common - sidebar</div>
                    <a title="Legenda" href="/dashboard" target="_blank">
                      Dashboard / Map
                    </a>
                    <a
                      title="Legenda, Testo cella <td> singolo"
                      href="/de446de09228/active/FCAMobile-S1mda/overal"
                      target="_blank"
                    >
                      Overall
                    </a>
                    <a title="Descrizione" href="/dashboard" target="_blank">
                      Dashboard / Probes View
                    </a>
                    <a
                      title="Testo cella <td> singolo"
                      href="/de446de09228/active"
                      target="_blank"
                    >
                      Active measures
                    </a>
                    <a
                      title="Testo cella <td> singolo, Testo singolo form"
                      href="/de446db4cce3/config"
                      target="_blank"
                    >
                      Measures setup / modal
                    </a>
                    <a
                      title="Testo cella <td> singolo, Testo singolo form"
                      href="/probconf"
                      target="_blank"
                    >
                      Probes management / modal
                    </a>
                    <a
                      title="Testo cella <td> singolo"
                      href="/de446de09228/active/FCAMobile-S1mda/overal/results/1592280960/i"
                      target="_blank"
                    >
                      Results
                    </a>
                    <a
                      title="Testo cella <td> singolo, Titolo sezione modale"
                      href="/sdconf"
                      target="_blank"
                    >
                      SD Conf / modal
                    </a>
                    <a
                      title="Testo cella <td> singolo"
                      href="/de446de09228/archived"
                      target="_blank"
                    >
                      Archived measures
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Menu tabella, Titolo 1 cella <td>, Titolo inizio sezione",
                render: (
                  <Link
                    to={{
                      pathname: "/a12/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div>
                      <div>
                        {" "}
                        <strong>Titolo menu tabella</strong>{" "}
                      </div>
                      <div>
                        <strong>Titolo 1 cella &lt;td&gt;</strong>
                      </div>
                      <div>
                        <strong>Titolo inizio sezione</strong>
                      </div>
                      <div>
                        <strong>Titolo legenda</strong>
                      </div>
                      <div>
                        <strong>Titolo tabella dx</strong>
                      </div>
                      <div>
                        <strong>Titolo sezione modale</strong>
                      </div>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "strong, font-size:16px",
                render: "strong, font-size:16px",
              },
              color: {
                value: "#212529",
                render: "#212529",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a
                      title="Titolo menu tabella"
                      href="/de446de09228/active/FCAMobile-S1mda/overal/results/1592280960/i"
                      target="_blank"
                    >
                      Results
                    </a>
                    <a
                      title="Titolo 1 cella <td>, Titolo inizio sezione"
                      href="/de446de09228/setup/general"
                      target="_blank"
                    >
                      Device setup
                    </a>

                    <a title="Titolo 1 cella <td>" href="/dashboard" target="_blank">
                      Dashboard / Diagnostic
                    </a>
                    <a title="Titolo inizio sezione" href="/account" target="_blank">
                      Account settings
                    </a>
                    <a
                      title="Titolo inizio sezione"
                      href="/de446db4cce3/active/FCAMobile-k31ZL/ccd539bb7fc5"
                      target="_blank"
                    >
                      Active
                    </a>
                    <a
                      title="Titolo inizio sezione, Titolo legenda"
                      href="/dashboard"
                      target="_blank"
                    >
                      Dashboard / Map
                    </a>
                    <a href="/probconf" target="_blank">
                      Probes management / Modal
                    </a>
                    <a
                      title="Titolo inizio sezione"
                      href="/de446db4cce3/config"
                      target="_blank"
                    >
                      Measures setup / Modal
                    </a>
                    <a
                      title="Titolo inizio sezione"
                      href="/de446de09228/active/FCAMobile-S1mda/overal"
                      target="_blank"
                    >
                      Overall
                    </a>
                    <a title="Titolo inizio sezione" href="/dashboard" target="_blank">
                      Dashboard / Probes View
                    </a>
                    <a title="Titolo tabella dx" href="/sdconf" target="_blank">
                      SD Conf
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Sottotitoli",
                render: (
                  <div>
                    <Link
                      to={{
                        pathname: "/a13/fontdemo",
                      }}
                      target="_blank"
                    >
                      <div className="text-muted">
                        <small>Sottotitoli</small>
                      </div>
                    </Link>
                  </div>
                ),
              },
              size: {
                value: "font-size:14.4px",
                render: "font-size:14.4px",
              },
              color: {
                value: "#6c757d",
                render: "#6c757d",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Probes View
                    </a>
                    <a href="/de446de09228/active" target="_blank">
                      Active measures
                    </a>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Diagnostic
                    </a>
                    <a href="/probconf" target="_blank">
                      Probes management
                    </a>
                    <a href="/de446de09228/setup/general" target="_blank">
                      Device setup
                    </a>
                    <a href="/account" target="_blank">
                      Account setting
                    </a>
                    <a
                      href="/de446db4cce3/active/FCAMobile-k31ZL/ccd539bb7fc5"
                      target="_blank"
                    >
                      Active
                    </a>
                    <a href="/de446db4cce3/config" target="_blank">
                      Measures setup
                    </a>
                    <a href="/de446de09228/active/FCAMobile-S1mda/overal" target="_blank">
                      Overall
                    </a>
                    <a
                      href="/de446de09228/active/FCAMobile-S1mda/overal/results/1592280960/i"
                      target="_blank"
                    >
                      Results
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Sottotitolo cella su sfondo scuro",
                render: (
                  <Link
                    to={{
                      pathname: "/a14/fontdemo",
                    }}
                    target="_blank"
                  >
                    {" "}
                    <div className="p-2 popup-top-bar sub-title-light">
                      <small>Sottotitolo cella su sfondo scuro</small>
                    </div>{" "}
                  </Link>
                ),
              },
              size: {
                value: "font-size:14.4px",
                render: "font-size:14.4px",
              },
              color: {
                value: "#e9ecef",
                render: "#e9ecef",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Map
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Titoletti / Label form",
                render: (
                  <Link
                    to={{
                      pathname: "/a15/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="text-muted">
                      <small>
                        <strong>Titoletti, Label form</strong>
                      </small>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "strong, font-size:14.4px",
                render: "strong, font-size:14.4px",
              },
              color: {
                value: "#6c757d",
                render: "#6c757d",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <div>Common - sidebar </div>
                    <a href="/de446de09228/active/FCAMobile-S1mda/overal" target="_blank">
                      Overall
                    </a>
                    <a
                      href="/de446de09228/active/FCAMobile-S1mda/overal/results/1592280960/i"
                      target="_blank"
                    >
                      Results
                    </a>
                    <a
                      href="/de446db4cce3/active/FCAMobile-k31ZL/ccd539bb7fc5"
                      target="_blank"
                    >
                      Active
                    </a>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Diag
                    </a>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Probes View
                    </a>
                    <a href="/de446de09228/active" target="_blank">
                      Active measures
                    </a>
                    <a href="/de446de09228/archived" target="_blank">
                      Archived measures
                    </a>
                    <a href="/account" target="_blank">
                      Account settings
                    </a>
                    <a href="/de446db4cce3/setup/general" target="_blank">
                      Device setup
                    </a>
                    <a href="/probconf" target="_blank">
                      Probes management / modal
                    </a>
                    <a href="/de446db4cce3/config" target="_blank">
                      Measures setup / modal
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Testo bottone",
                render: (
                  <Link
                    to={{
                      pathname: "/a21/fontdemo",
                    }}
                    target="_blank"
                  >
                    <ReactOButton color="primary">Testo bottone</ReactOButton>
                  </Link>
                ),
              },
              size: {
                value: "font-size:16px",
                render: "font-size:16px",
              },
              color: {
                value: "#ffffff",
                render: "#ffffff",
              },
              pages: {
                value: "link",
                render: "All",
              },
            },
            {
              elem: {
                value: "Testo bottone card",
                render: (
                  <Link
                    to={{
                      pathname: "/a22/fontdemo",
                    }}
                    target="_blank"
                  >
                    {" "}
                    <ReactOButton color="primary" size="sm">
                      Testo bottone card
                    </ReactOButton>
                  </Link>
                ),
              },
              size: {
                value: "font-size:14px",
                render: "font-size:14px",
              },
              color: {
                value: "#ffffff",
                render: "#ffffff",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Probes View
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Link selezione dashboard",
                render: (
                  <Link
                    to={{
                      pathname: "/a23/fontdemo",
                    }}
                    target="_blank"
                  >
                    <ReactOButton color="primary">
                      <strong>Testo bottone vista dashboard</strong>
                    </ReactOButton>
                  </Link>
                ),
              },
              size: {
                value: "strong, font-size:16px",
                render: "strong, font-size:16px",
              },
              color: {
                value: "#ffffff",
                render: "#ffffff",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Probes View
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Testo cella <td> singolo su sfondo scuro",
                render: (
                  <Link
                    to={{
                      pathname: "/a27/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="p-2 popup-top-bar">
                      <div className="text-light">
                        <div>Testo cella &lt;td&gt; singolo su sfondo scuro</div>
                      </div>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "font-size:16px",
                render: "font-size:16px",
              },
              color: {
                value: "#f8f9fa",
                render: "#f8f9fa",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Map
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Testo cella <td> singolo",
                render: (
                  <Link
                    to={{
                      pathname: "/a24/fontdemo",
                    }}
                    target="_blank"
                  >
                    {" "}
                    <div className="text-danger">Testo cella &lt;td&gt; singolo</div>{" "}
                  </Link>
                ),
              },
              size: {
                value: "font-size:16px",
                render: "font-size:16px",
              },
              color: {
                value: "#dc3545",
                render: "Danger - #dc3545",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Diag
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Testo cella <td> singolo",
                render: (
                  <Link
                    to={{
                      pathname: "/a25/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="text-warning">Testo cella &lt;td&gt; singolo</div>
                  </Link>
                ),
              },
              size: {
                value: "font-size:16px",
                render: "font-size:16px",
              },
              color: {
                value: "#ffc107",
                render: "Warning - #ffc107",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Diag
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Testo cella <td> singolo",
                render: (
                  <Link
                    to={{
                      pathname: "/a26/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="text-success">Testo cella &lt;td&gt; singolo</div>
                  </Link>
                ),
              },
              size: {
                value: "font-size:16px",
                render: "font-size:16px",
              },
              color: {
                value: "#28a745",
                render: "Success - #28a745",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Diag
                    </a>
                  </div>
                ),
              },
            },

            {
              elem: {
                value: "Testo informazioni inizio pagina dx",
                render: (
                  <Link
                    to={{
                      pathname: "/a28/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="text-muted">
                      <small>
                        <strong className="text-danger">
                          Testo informazioni inizio pagina dx
                        </strong>
                      </small>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "strong, font-size:14.4px",
                render: "strong, font-size:14.4px",
              },
              color: {
                value: "#dc3545",
                render: "Danger - #dc3545",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    {" "}
                    <a href="/de446de09228/active" target="_blank">
                      Active measures
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Testo informazioni inizio pagina dx",
                render: (
                  <Link
                    to={{
                      pathname: "/a29/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="text-muted">
                      <small>
                        <strong className="text-warning">
                          Testo informazioni inizio pagina dx
                        </strong>
                      </small>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "strong, font-size:14.4px",
                render: "strong, font-size:14.4px",
              },
              color: {
                value: "#ffc107",
                render: "Warning - #ffc107",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    {" "}
                    <a href="/de446de09228/active" target="_blank">
                      Active measures
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Testo informazioni inizio pagina dx",
                render: (
                  <Link
                    to={{
                      pathname: "/a30/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="text-muted">
                      <small>
                        <strong className="text-success">
                          Testo informazioni inizio pagina dx
                        </strong>
                      </small>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "strong, font-size:14.4px",
                render: "strong, font-size:14.4px",
              },
              color: {
                value: "#28a745",
                render: "Success - #28a745",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    {" "}
                    <a href="/de446de09228/active" target="_blank">
                      Active measures
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Titolo finestra overlay",
                render: (
                  <Link
                    to={{
                      pathname: "/a32/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="p-2 popup-top-bar">
                      <h4 className="text-light">Titolo finestra overlay</h4>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "h4, font-size:24px",
                render: "h4, font-size:24px",
              },
              color: {
                value: "#f8f9fa",
                render: "#f8f9fa",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Map
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Titolo 1 cella <td> su sfondo scuro",
                render: (
                  <Link
                    to={{
                      pathname: "/a31/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="p-2 popup-top-bar">
                      <div className="text-light">
                        <strong>Titolo 1 cella &lt;td&gt; su sfondo scuro</strong>
                      </div>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "strong, font-size:16x",
                render: "strong, font-size:16px",
              },
              color: {
                value: "#e9ecef",
                render: "#e9ecef",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Map
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Titolo modale",
                render: (
                  <Link
                    to={{
                      pathname: "/a33/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div>
                      <h5>Titolo cella &lt;td&gt;</h5>
                      <h5>Titolo modale</h5>
                      <h5>Titolo 2 pagina</h5>
                      <h5>Titolo card</h5>
                      <h5>Titolo sidebar</h5>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "h5, font-size:20px",
                render: "h5, font-size:20px",
              },
              color: {
                value: "#343a40",
                render: "#343a40",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a title="Titolo modale" href="/de446db4cce3/config" target="_blank">
                      Measures setup / Modal
                    </a>
                    <a title="Titolo modale" href="/probconf" target="_blank">
                      Probes management / Modal
                    </a>
                    <a href="/de446de09228/active" target="_blank">
                      Active measures
                    </a>
                    <a title="Titolo cella" href="/probconf" target="_blank">
                      Probes management
                    </a>
                    <a
                      title="Titolo cella, titolo 2 pagina"
                      href="/sdconf"
                      target="_blank"
                    >
                      SD Conf
                    </a>
                    <a title="Titolo cella" href="/de446de09228/archived" target="_blank">
                      Archived measures
                    </a>
                    <a title="Titolo card" href="/dashboard" target="_blank">
                      Dashboard / Probes View
                    </a>
                    <div>Common - sidebar</div>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Titolo pagina",
                render: (
                  <Link
                    to={{
                      pathname: "/a34/fontdemo",
                    }}
                    target="_blank"
                  >
                    <h2>Titolo principale pagina</h2>{" "}
                  </Link>
                ),
              },
              size: {
                value: "h2, font-size:32px",
                render: "h2, font-size:32px",
              },
              color: {
                value: "#212529",
                render: "#212529",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a href="/account" target="_blank">
                      Account settings
                    </a>
                    <a
                      href="/de446db4cce3/active/FCAMobile-k31ZL/ccd539bb7fc5"
                      target="_blank"
                    >
                      Active
                    </a>
                    <a href="/de446de09228/setup/general" target="_blank">
                      Device setup
                    </a>

                    <a href="/de446db4cce3/config" target="_blank">
                      Measures setup
                    </a>
                    <a href="/de446de09228/active/FCAMobile-S1mda/overal" target="_blank">
                      Overall
                    </a>
                    <a href="/de446de09228/archived" target="_blank">
                      Archived measures
                    </a>
                    <a
                      href="/de446de09228/active/FCAMobile-S1mda/overal/results/1592280960/i"
                      target="_blank"
                    >
                      Results
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Titolo tabella",
                render: (
                  <Link
                    to={{
                      pathname: "/a35/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="p-2 diag-bg">
                      <h5>Titolo tabella</h5>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "h5, font-size:20px",
                render: "h5, font-size:20px",
              },
              color: {
                value: "#721c24",
                render: "#721c24",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    {" "}
                    <a href="/dashboard" target="_blank">
                      Dashboard / Diagnostic
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Titolo tabella",
                render: (
                  <Link
                    to={{
                      pathname: "/a36/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="p-2 maintenance-bg">
                      <h5>Titolo tabella</h5>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "h5, font-size:20px",
                render: "h5, font-size:20px",
              },
              color: {
                value: "#72431c",
                render: "#72431c",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    {" "}
                    <a href="/dashboard" target="_blank">
                      Dashboard / Diagnostic
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Titolo tabella",
                render: (
                  <Link
                    to={{
                      pathname: "/a37/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="p-2 working-bg">
                      <h5>Titolo tabella</h5>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "h5, font-size:20px",
                render: "h5, font-size:20px",
              },
              color: {
                value: "#135713",
                render: "#135713",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    {" "}
                    <a href="/dashboard" target="_blank">
                      Dashboard / Diagnostic
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Titolo tabella dx",
                render: (
                  <Link
                    to={{
                      pathname: "/a38/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="p-2 diag-bg">
                      <strong>Titolo tabella dx</strong>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "font-size:16px",
                render: "font-size:16px",
              },
              color: {
                value: "#721c24",
                render: "#721c24",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Map
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Titolo tabella dx",
                render: (
                  <Link
                    to={{
                      pathname: "/a39/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="p-2 maintenance-bg">
                      <strong>Titolo tabella dx</strong>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "font-size:16px",
                render: "font-size:16px",
              },
              color: {
                value: "#72431c",
                render: "#72431c",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Map
                    </a>
                  </div>
                ),
              },
            },
            {
              elem: {
                value: "Titolo tabella dx",
                render: (
                  <Link
                    to={{
                      pathname: "/a40/fontdemo",
                    }}
                    target="_blank"
                  >
                    <div className="p-2 working-bg">
                      <strong>Titolo tabella dx</strong>
                    </div>
                  </Link>
                ),
              },
              size: {
                value: "font-size:16px",
                render: "font-size:16px",
              },
              color: {
                value: "#135713",
                render: "#135713",
              },
              pages: {
                value: "link",
                render: (
                  <div>
                    <a href="/dashboard" target="_blank">
                      Dashboard / Map
                    </a>
                  </div>
                ),
              },
            },
          ]}
        />
      </Section>
    );
  }
}

export default contextProvider(Dev, {
  define: null,
});
